import React from "react";
import { Button, Typography } from "antd";
import AdvisorPng from '../../assets/images/advisor.png'
import RequestCallbackModal from "../../components/RequestCallbackModal";

export default function RequestCall() {

  return <div className="bg-blue-900">
    <section className="flex items-center justify-between flex-col-reverse gap-4 md:flex-row-reverse px-4 md:!px-32 section">
      <div className="max-w-96" >
        <Typography.Title className="!text-white" >Talk to our Advisor</Typography.Title>
        <Typography.Text className="!text-white" >
          {/* <ul>
        
<li>AI-based Learning for personalized progress</li>
<li>Exclusive Learning Resources for advanced skills</li>
<li>Specialized Skill Development to make you industry-ready</li>
<li>Hands-on Workshops to sharpen real-world abilities</li>
<li>Comprehensive Placement Preparation for career success</li>
<li>1:1 Mentorship Sessions Daily with industry professionals</li>
No Prior Coding Experience Required
          </ul> */}
        </Typography.Text>
        <RequestCallbackModal buttonComp={
          <Button type="default" size="large" className="mt-4"  >Request a Call</Button>

        } />

      </div>
      <div className="max-w-96">
        <img src={AdvisorPng} className="max-w-72 rounded-2xl" />
      </div>
    </section>
  </div>
  return (
    <section className="containerLayout py-10 flex flex-col md:flex-row justify-between gap-2 bg-gray-800 text-white">
      <div className="flex flex-col gap-2">
        <Typography variant="h3-title">Talk to our Advisor</Typography>
        <Typography variant="h4-title">AND GET</Typography>
        <ul>
          <Typography variant="p-text">Personalize Career Roadmap</Typography>
          <Typography variant="p-text">Free Career Counseling</Typography>
          <Typography variant="p-text">
            Free access to Pronttera Labs Events
          </Typography>
        </ul>
        <Button>Request a Call</Button>
      </div>
      <div className="">
        <img
          src="https://cdn.pixabay.com/photo/2022/08/09/03/10/call-center-7374023_1280.png"
          alt="Request Call Img"
          className="h-[15rem]"
        />
      </div>
    </section>
  );
}
